/**
 * Map colours as hex. Mapbox paint properties, and the marker colour Mapbox draws, are
 * resolved by Mapbox itself, not by the browser's CSS, so they cannot read var(--color-…).
 * Every value here is the hex of a design token in web-shared/src/design/tokens.css, and
 * map-colours.test.ts fails if the two drift apart. This is the one dispatch file the
 * hex-colour guard allows.
 */
export const MAP_COLOURS = {
  /** --color-accent-blue: a geofence, the GPS trail's start. */
  accent: '#7b96e8',
  /** --color-success: the GPS trail's end. */
  success: '#6fcf8e',
  /** --color-warning: a GPS event on the trail. */
  warning: '#f6b65e',
  /** --color-paper: a vertex handle, an outline on a pin. */
  paper: '#ffffff',
  /** --color-bg-rail: the dark ring and count on a map-layer site dot. */
  ink: '#141518',
  /** --color-tone-teal: pickup sites (amber already means a Busy driver pin). */
  pickup: '#5fc4c0',
  /** --color-tone-violet: disposal sites. */
  disposal: '#c49bf0',
  /** --color-link: route lines. */
  route: '#8fa6f0',
} as const;

/** The token each colour mirrors (read by the drift test). */
export const MAP_COLOUR_TOKENS: Readonly<Record<keyof typeof MAP_COLOURS, string>> = {
  accent: '--color-accent-blue',
  success: '--color-success',
  warning: '--color-warning',
  paper: '--color-paper',
  ink: '--color-bg-rail',
  pickup: '--color-tone-teal',
  disposal: '--color-tone-violet',
  route: '--color-link',
};
